import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=3d4169d2&scoped=true"
import script from "./OtpInput.vue?vue&type=script&lang=js"
export * from "./OtpInput.vue?vue&type=script&lang=js"
import style0 from "./OtpInput.vue?vue&type=style&index=0&id=3d4169d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4169d2",
  null
  
)

export default component.exports